import { Button, Stack } from 'shell/components';

const sk =
    'sk_test_51OUwzODxdlclOtZZa0u2RwwCvw9zxldj4MCJ6uIX6pPuLZsXSWEwfPVqKxz3UC6yKN6ZgNAIY2PIVmdD3Snf6ssa00ItLCP1nl';

const StripePage = () => {
    const onClickLogCustomers = async () => {
        const response = await fetch('https://api.stripe.com/v1/subscriptions', {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${sk}`,
            },
        });
        const result = await response.json();
        console.log(result);
    };
    return (
        <Stack alignItems={'flex-start'}>
            <Button onClick={onClickLogCustomers}>Log</Button>
        </Stack>
    );
};

export default StripePage;
